export class UserAuthConstants {
    /**
     * The interval in milliseconds at which the application checks the user's session validity with Auth0
     * in the background.
     */
    public static readonly AUTH0_SESSION_VALIDATION_INTERVAL: number = 300000; // 5 minutes

    public static readonly SessionExpiredModalTitle = 'Session Expired';
    public static readonly SessionExpiredModalContent =
        'Your session has expired. Please log in again to continue.';
    public static readonly SessionExpiredModalPrimaryAction = 'OK';
}
